// Static list of IANA timezone identifiers, generated from Python's
// zoneinfo.available_timezones() (tzdata), filtered of deprecated aliases
// (posix/*, right/*, Etc/GMT±N, SystemV/*, "Factory", "localtime").
//
// IANA_TIMEZONES: [{ value, region }] — value is the canonical zone name
// (e.g. "Asia/Kolkata"), region is the leading path segment used for
// grouping in the picker (e.g. "Asia"). Zones with no "/" (legacy POSIX
// names like "EST", "UTC") are grouped under "Other".
export const IANA_TIMEZONES = [
  { value: "Africa/Abidjan", region: "Africa" },
  { value: "Africa/Accra", region: "Africa" },
  { value: "Africa/Addis_Ababa", region: "Africa" },
  { value: "Africa/Algiers", region: "Africa" },
  { value: "Africa/Asmara", region: "Africa" },
  { value: "Africa/Bamako", region: "Africa" },
  { value: "Africa/Bangui", region: "Africa" },
  { value: "Africa/Banjul", region: "Africa" },
  { value: "Africa/Bissau", region: "Africa" },
  { value: "Africa/Blantyre", region: "Africa" },
  { value: "Africa/Brazzaville", region: "Africa" },
  { value: "Africa/Bujumbura", region: "Africa" },
  { value: "Africa/Cairo", region: "Africa" },
  { value: "Africa/Casablanca", region: "Africa" },
  { value: "Africa/Ceuta", region: "Africa" },
  { value: "Africa/Conakry", region: "Africa" },
  { value: "Africa/Dakar", region: "Africa" },
  { value: "Africa/Dar_es_Salaam", region: "Africa" },
  { value: "Africa/Djibouti", region: "Africa" },
  { value: "Africa/Douala", region: "Africa" },
  { value: "Africa/El_Aaiun", region: "Africa" },
  { value: "Africa/Freetown", region: "Africa" },
  { value: "Africa/Gaborone", region: "Africa" },
  { value: "Africa/Harare", region: "Africa" },
  { value: "Africa/Johannesburg", region: "Africa" },
  { value: "Africa/Juba", region: "Africa" },
  { value: "Africa/Kampala", region: "Africa" },
  { value: "Africa/Khartoum", region: "Africa" },
  { value: "Africa/Kigali", region: "Africa" },
  { value: "Africa/Kinshasa", region: "Africa" },
  { value: "Africa/Lagos", region: "Africa" },
  { value: "Africa/Libreville", region: "Africa" },
  { value: "Africa/Lome", region: "Africa" },
  { value: "Africa/Luanda", region: "Africa" },
  { value: "Africa/Lubumbashi", region: "Africa" },
  { value: "Africa/Lusaka", region: "Africa" },
  { value: "Africa/Malabo", region: "Africa" },
  { value: "Africa/Maputo", region: "Africa" },
  { value: "Africa/Maseru", region: "Africa" },
  { value: "Africa/Mbabane", region: "Africa" },
  { value: "Africa/Mogadishu", region: "Africa" },
  { value: "Africa/Monrovia", region: "Africa" },
  { value: "Africa/Nairobi", region: "Africa" },
  { value: "Africa/Ndjamena", region: "Africa" },
  { value: "Africa/Niamey", region: "Africa" },
  { value: "Africa/Nouakchott", region: "Africa" },
  { value: "Africa/Ouagadougou", region: "Africa" },
  { value: "Africa/Porto-Novo", region: "Africa" },
  { value: "Africa/Sao_Tome", region: "Africa" },
  { value: "Africa/Timbuktu", region: "Africa" },
  { value: "Africa/Tripoli", region: "Africa" },
  { value: "Africa/Tunis", region: "Africa" },
  { value: "Africa/Windhoek", region: "Africa" },
  { value: "America/Adak", region: "America" },
  { value: "America/Anchorage", region: "America" },
  { value: "America/Anguilla", region: "America" },
  { value: "America/Antigua", region: "America" },
  { value: "America/Araguaina", region: "America" },
  { value: "America/Argentina/Buenos_Aires", region: "America" },
  { value: "America/Argentina/Catamarca", region: "America" },
  { value: "America/Argentina/Cordoba", region: "America" },
  { value: "America/Argentina/Jujuy", region: "America" },
  { value: "America/Argentina/La_Rioja", region: "America" },
  { value: "America/Argentina/Mendoza", region: "America" },
  { value: "America/Argentina/Rio_Gallegos", region: "America" },
  { value: "America/Argentina/Salta", region: "America" },
  { value: "America/Argentina/San_Juan", region: "America" },
  { value: "America/Argentina/San_Luis", region: "America" },
  { value: "America/Argentina/Tucuman", region: "America" },
  { value: "America/Argentina/Ushuaia", region: "America" },
  { value: "America/Aruba", region: "America" },
  { value: "America/Asuncion", region: "America" },
  { value: "America/Atikokan", region: "America" },
  { value: "America/Atka", region: "America" },
  { value: "America/Bahia", region: "America" },
  { value: "America/Bahia_Banderas", region: "America" },
  { value: "America/Barbados", region: "America" },
  { value: "America/Belem", region: "America" },
  { value: "America/Belize", region: "America" },
  { value: "America/Blanc-Sablon", region: "America" },
  { value: "America/Boa_Vista", region: "America" },
  { value: "America/Bogota", region: "America" },
  { value: "America/Boise", region: "America" },
  { value: "America/Cambridge_Bay", region: "America" },
  { value: "America/Campo_Grande", region: "America" },
  { value: "America/Cancun", region: "America" },
  { value: "America/Caracas", region: "America" },
  { value: "America/Cayenne", region: "America" },
  { value: "America/Cayman", region: "America" },
  { value: "America/Chicago", region: "America" },
  { value: "America/Chihuahua", region: "America" },
  { value: "America/Ciudad_Juarez", region: "America" },
  { value: "America/Coral_Harbour", region: "America" },
  { value: "America/Costa_Rica", region: "America" },
  { value: "America/Coyhaique", region: "America" },
  { value: "America/Creston", region: "America" },
  { value: "America/Cuiaba", region: "America" },
  { value: "America/Curacao", region: "America" },
  { value: "America/Danmarkshavn", region: "America" },
  { value: "America/Dawson", region: "America" },
  { value: "America/Dawson_Creek", region: "America" },
  { value: "America/Denver", region: "America" },
  { value: "America/Detroit", region: "America" },
  { value: "America/Dominica", region: "America" },
  { value: "America/Edmonton", region: "America" },
  { value: "America/Eirunepe", region: "America" },
  { value: "America/El_Salvador", region: "America" },
  { value: "America/Ensenada", region: "America" },
  { value: "America/Fort_Nelson", region: "America" },
  { value: "America/Fortaleza", region: "America" },
  { value: "America/Glace_Bay", region: "America" },
  { value: "America/Goose_Bay", region: "America" },
  { value: "America/Grand_Turk", region: "America" },
  { value: "America/Grenada", region: "America" },
  { value: "America/Guadeloupe", region: "America" },
  { value: "America/Guatemala", region: "America" },
  { value: "America/Guayaquil", region: "America" },
  { value: "America/Guyana", region: "America" },
  { value: "America/Halifax", region: "America" },
  { value: "America/Havana", region: "America" },
  { value: "America/Hermosillo", region: "America" },
  { value: "America/Indiana/Indianapolis", region: "America" },
  { value: "America/Indiana/Knox", region: "America" },
  { value: "America/Indiana/Marengo", region: "America" },
  { value: "America/Indiana/Petersburg", region: "America" },
  { value: "America/Indiana/Tell_City", region: "America" },
  { value: "America/Indiana/Vevay", region: "America" },
  { value: "America/Indiana/Vincennes", region: "America" },
  { value: "America/Indiana/Winamac", region: "America" },
  { value: "America/Inuvik", region: "America" },
  { value: "America/Iqaluit", region: "America" },
  { value: "America/Jamaica", region: "America" },
  { value: "America/Juneau", region: "America" },
  { value: "America/Kentucky/Louisville", region: "America" },
  { value: "America/Kentucky/Monticello", region: "America" },
  { value: "America/Kralendijk", region: "America" },
  { value: "America/La_Paz", region: "America" },
  { value: "America/Lima", region: "America" },
  { value: "America/Los_Angeles", region: "America" },
  { value: "America/Lower_Princes", region: "America" },
  { value: "America/Maceio", region: "America" },
  { value: "America/Managua", region: "America" },
  { value: "America/Manaus", region: "America" },
  { value: "America/Marigot", region: "America" },
  { value: "America/Martinique", region: "America" },
  { value: "America/Matamoros", region: "America" },
  { value: "America/Mazatlan", region: "America" },
  { value: "America/Menominee", region: "America" },
  { value: "America/Merida", region: "America" },
  { value: "America/Metlakatla", region: "America" },
  { value: "America/Mexico_City", region: "America" },
  { value: "America/Miquelon", region: "America" },
  { value: "America/Moncton", region: "America" },
  { value: "America/Monterrey", region: "America" },
  { value: "America/Montevideo", region: "America" },
  { value: "America/Montreal", region: "America" },
  { value: "America/Montserrat", region: "America" },
  { value: "America/Nassau", region: "America" },
  { value: "America/New_York", region: "America" },
  { value: "America/Nipigon", region: "America" },
  { value: "America/Nome", region: "America" },
  { value: "America/Noronha", region: "America" },
  { value: "America/North_Dakota/Beulah", region: "America" },
  { value: "America/North_Dakota/Center", region: "America" },
  { value: "America/North_Dakota/New_Salem", region: "America" },
  { value: "America/Nuuk", region: "America" },
  { value: "America/Ojinaga", region: "America" },
  { value: "America/Panama", region: "America" },
  { value: "America/Pangnirtung", region: "America" },
  { value: "America/Paramaribo", region: "America" },
  { value: "America/Phoenix", region: "America" },
  { value: "America/Port-au-Prince", region: "America" },
  { value: "America/Port_of_Spain", region: "America" },
  { value: "America/Porto_Acre", region: "America" },
  { value: "America/Porto_Velho", region: "America" },
  { value: "America/Puerto_Rico", region: "America" },
  { value: "America/Punta_Arenas", region: "America" },
  { value: "America/Rainy_River", region: "America" },
  { value: "America/Rankin_Inlet", region: "America" },
  { value: "America/Recife", region: "America" },
  { value: "America/Regina", region: "America" },
  { value: "America/Resolute", region: "America" },
  { value: "America/Rio_Branco", region: "America" },
  { value: "America/Santa_Isabel", region: "America" },
  { value: "America/Santarem", region: "America" },
  { value: "America/Santiago", region: "America" },
  { value: "America/Santo_Domingo", region: "America" },
  { value: "America/Sao_Paulo", region: "America" },
  { value: "America/Scoresbysund", region: "America" },
  { value: "America/Shiprock", region: "America" },
  { value: "America/Sitka", region: "America" },
  { value: "America/St_Barthelemy", region: "America" },
  { value: "America/St_Johns", region: "America" },
  { value: "America/St_Kitts", region: "America" },
  { value: "America/St_Lucia", region: "America" },
  { value: "America/St_Thomas", region: "America" },
  { value: "America/St_Vincent", region: "America" },
  { value: "America/Swift_Current", region: "America" },
  { value: "America/Tegucigalpa", region: "America" },
  { value: "America/Thule", region: "America" },
  { value: "America/Thunder_Bay", region: "America" },
  { value: "America/Tijuana", region: "America" },
  { value: "America/Toronto", region: "America" },
  { value: "America/Tortola", region: "America" },
  { value: "America/Vancouver", region: "America" },
  { value: "America/Virgin", region: "America" },
  { value: "America/Whitehorse", region: "America" },
  { value: "America/Winnipeg", region: "America" },
  { value: "America/Yakutat", region: "America" },
  { value: "America/Yellowknife", region: "America" },
  { value: "Antarctica/Casey", region: "Antarctica" },
  { value: "Antarctica/Davis", region: "Antarctica" },
  { value: "Antarctica/DumontDUrville", region: "Antarctica" },
  { value: "Antarctica/Macquarie", region: "Antarctica" },
  { value: "Antarctica/Mawson", region: "Antarctica" },
  { value: "Antarctica/McMurdo", region: "Antarctica" },
  { value: "Antarctica/Palmer", region: "Antarctica" },
  { value: "Antarctica/Rothera", region: "Antarctica" },
  { value: "Antarctica/Syowa", region: "Antarctica" },
  { value: "Antarctica/Troll", region: "Antarctica" },
  { value: "Antarctica/Vostok", region: "Antarctica" },
  { value: "Arctic/Longyearbyen", region: "Arctic" },
  { value: "Asia/Aden", region: "Asia" },
  { value: "Asia/Almaty", region: "Asia" },
  { value: "Asia/Amman", region: "Asia" },
  { value: "Asia/Anadyr", region: "Asia" },
  { value: "Asia/Aqtau", region: "Asia" },
  { value: "Asia/Aqtobe", region: "Asia" },
  { value: "Asia/Ashgabat", region: "Asia" },
  { value: "Asia/Atyrau", region: "Asia" },
  { value: "Asia/Baghdad", region: "Asia" },
  { value: "Asia/Bahrain", region: "Asia" },
  { value: "Asia/Baku", region: "Asia" },
  { value: "Asia/Bangkok", region: "Asia" },
  { value: "Asia/Barnaul", region: "Asia" },
  { value: "Asia/Beirut", region: "Asia" },
  { value: "Asia/Bishkek", region: "Asia" },
  { value: "Asia/Brunei", region: "Asia" },
  { value: "Asia/Chita", region: "Asia" },
  { value: "Asia/Choibalsan", region: "Asia" },
  { value: "Asia/Chongqing", region: "Asia" },
  { value: "Asia/Colombo", region: "Asia" },
  { value: "Asia/Damascus", region: "Asia" },
  { value: "Asia/Dhaka", region: "Asia" },
  { value: "Asia/Dili", region: "Asia" },
  { value: "Asia/Dubai", region: "Asia" },
  { value: "Asia/Dushanbe", region: "Asia" },
  { value: "Asia/Famagusta", region: "Asia" },
  { value: "Asia/Gaza", region: "Asia" },
  { value: "Asia/Harbin", region: "Asia" },
  { value: "Asia/Hebron", region: "Asia" },
  { value: "Asia/Ho_Chi_Minh", region: "Asia" },
  { value: "Asia/Hong_Kong", region: "Asia" },
  { value: "Asia/Hovd", region: "Asia" },
  { value: "Asia/Irkutsk", region: "Asia" },
  { value: "Asia/Istanbul", region: "Asia" },
  { value: "Asia/Jakarta", region: "Asia" },
  { value: "Asia/Jayapura", region: "Asia" },
  { value: "Asia/Jerusalem", region: "Asia" },
  { value: "Asia/Kabul", region: "Asia" },
  { value: "Asia/Kamchatka", region: "Asia" },
  { value: "Asia/Karachi", region: "Asia" },
  { value: "Asia/Kashgar", region: "Asia" },
  { value: "Asia/Kathmandu", region: "Asia" },
  { value: "Asia/Khandyga", region: "Asia" },
  { value: "Asia/Kolkata", region: "Asia" },
  { value: "Asia/Krasnoyarsk", region: "Asia" },
  { value: "Asia/Kuala_Lumpur", region: "Asia" },
  { value: "Asia/Kuching", region: "Asia" },
  { value: "Asia/Kuwait", region: "Asia" },
  { value: "Asia/Macau", region: "Asia" },
  { value: "Asia/Magadan", region: "Asia" },
  { value: "Asia/Makassar", region: "Asia" },
  { value: "Asia/Manila", region: "Asia" },
  { value: "Asia/Muscat", region: "Asia" },
  { value: "Asia/Nicosia", region: "Asia" },
  { value: "Asia/Novokuznetsk", region: "Asia" },
  { value: "Asia/Novosibirsk", region: "Asia" },
  { value: "Asia/Omsk", region: "Asia" },
  { value: "Asia/Oral", region: "Asia" },
  { value: "Asia/Phnom_Penh", region: "Asia" },
  { value: "Asia/Pontianak", region: "Asia" },
  { value: "Asia/Pyongyang", region: "Asia" },
  { value: "Asia/Qatar", region: "Asia" },
  { value: "Asia/Qostanay", region: "Asia" },
  { value: "Asia/Qyzylorda", region: "Asia" },
  { value: "Asia/Riyadh", region: "Asia" },
  { value: "Asia/Sakhalin", region: "Asia" },
  { value: "Asia/Samarkand", region: "Asia" },
  { value: "Asia/Seoul", region: "Asia" },
  { value: "Asia/Shanghai", region: "Asia" },
  { value: "Asia/Singapore", region: "Asia" },
  { value: "Asia/Srednekolymsk", region: "Asia" },
  { value: "Asia/Taipei", region: "Asia" },
  { value: "Asia/Tashkent", region: "Asia" },
  { value: "Asia/Tbilisi", region: "Asia" },
  { value: "Asia/Tehran", region: "Asia" },
  { value: "Asia/Tel_Aviv", region: "Asia" },
  { value: "Asia/Thimphu", region: "Asia" },
  { value: "Asia/Tokyo", region: "Asia" },
  { value: "Asia/Tomsk", region: "Asia" },
  { value: "Asia/Ulaanbaatar", region: "Asia" },
  { value: "Asia/Urumqi", region: "Asia" },
  { value: "Asia/Ust-Nera", region: "Asia" },
  { value: "Asia/Vientiane", region: "Asia" },
  { value: "Asia/Vladivostok", region: "Asia" },
  { value: "Asia/Yakutsk", region: "Asia" },
  { value: "Asia/Yangon", region: "Asia" },
  { value: "Asia/Yekaterinburg", region: "Asia" },
  { value: "Asia/Yerevan", region: "Asia" },
  { value: "Atlantic/Azores", region: "Atlantic" },
  { value: "Atlantic/Bermuda", region: "Atlantic" },
  { value: "Atlantic/Canary", region: "Atlantic" },
  { value: "Atlantic/Cape_Verde", region: "Atlantic" },
  { value: "Atlantic/Faroe", region: "Atlantic" },
  { value: "Atlantic/Jan_Mayen", region: "Atlantic" },
  { value: "Atlantic/Madeira", region: "Atlantic" },
  { value: "Atlantic/Reykjavik", region: "Atlantic" },
  { value: "Atlantic/South_Georgia", region: "Atlantic" },
  { value: "Atlantic/St_Helena", region: "Atlantic" },
  { value: "Atlantic/Stanley", region: "Atlantic" },
  { value: "Australia/Adelaide", region: "Australia" },
  { value: "Australia/Brisbane", region: "Australia" },
  { value: "Australia/Broken_Hill", region: "Australia" },
  { value: "Australia/Canberra", region: "Australia" },
  { value: "Australia/Currie", region: "Australia" },
  { value: "Australia/Darwin", region: "Australia" },
  { value: "Australia/Eucla", region: "Australia" },
  { value: "Australia/Hobart", region: "Australia" },
  { value: "Australia/Lindeman", region: "Australia" },
  { value: "Australia/Lord_Howe", region: "Australia" },
  { value: "Australia/Melbourne", region: "Australia" },
  { value: "Australia/Perth", region: "Australia" },
  { value: "Australia/Sydney", region: "Australia" },
  { value: "Australia/Yancowinna", region: "Australia" },
  { value: "CET", region: "Other" },
  { value: "CST6CDT", region: "Other" },
  { value: "EET", region: "Other" },
  { value: "EST", region: "Other" },
  { value: "EST5EDT", region: "Other" },
  { value: "Etc/Greenwich", region: "Etc" },
  { value: "Etc/UCT", region: "Etc" },
  { value: "Etc/UTC", region: "Etc" },
  { value: "Etc/Universal", region: "Etc" },
  { value: "Etc/Zulu", region: "Etc" },
  { value: "Europe/Amsterdam", region: "Europe" },
  { value: "Europe/Andorra", region: "Europe" },
  { value: "Europe/Astrakhan", region: "Europe" },
  { value: "Europe/Athens", region: "Europe" },
  { value: "Europe/Belfast", region: "Europe" },
  { value: "Europe/Belgrade", region: "Europe" },
  { value: "Europe/Berlin", region: "Europe" },
  { value: "Europe/Bratislava", region: "Europe" },
  { value: "Europe/Brussels", region: "Europe" },
  { value: "Europe/Bucharest", region: "Europe" },
  { value: "Europe/Budapest", region: "Europe" },
  { value: "Europe/Busingen", region: "Europe" },
  { value: "Europe/Chisinau", region: "Europe" },
  { value: "Europe/Copenhagen", region: "Europe" },
  { value: "Europe/Dublin", region: "Europe" },
  { value: "Europe/Gibraltar", region: "Europe" },
  { value: "Europe/Guernsey", region: "Europe" },
  { value: "Europe/Helsinki", region: "Europe" },
  { value: "Europe/Isle_of_Man", region: "Europe" },
  { value: "Europe/Istanbul", region: "Europe" },
  { value: "Europe/Jersey", region: "Europe" },
  { value: "Europe/Kaliningrad", region: "Europe" },
  { value: "Europe/Kirov", region: "Europe" },
  { value: "Europe/Kyiv", region: "Europe" },
  { value: "Europe/Lisbon", region: "Europe" },
  { value: "Europe/Ljubljana", region: "Europe" },
  { value: "Europe/London", region: "Europe" },
  { value: "Europe/Luxembourg", region: "Europe" },
  { value: "Europe/Madrid", region: "Europe" },
  { value: "Europe/Malta", region: "Europe" },
  { value: "Europe/Mariehamn", region: "Europe" },
  { value: "Europe/Minsk", region: "Europe" },
  { value: "Europe/Monaco", region: "Europe" },
  { value: "Europe/Moscow", region: "Europe" },
  { value: "Europe/Nicosia", region: "Europe" },
  { value: "Europe/Oslo", region: "Europe" },
  { value: "Europe/Paris", region: "Europe" },
  { value: "Europe/Podgorica", region: "Europe" },
  { value: "Europe/Prague", region: "Europe" },
  { value: "Europe/Riga", region: "Europe" },
  { value: "Europe/Rome", region: "Europe" },
  { value: "Europe/Samara", region: "Europe" },
  { value: "Europe/San_Marino", region: "Europe" },
  { value: "Europe/Sarajevo", region: "Europe" },
  { value: "Europe/Saratov", region: "Europe" },
  { value: "Europe/Simferopol", region: "Europe" },
  { value: "Europe/Skopje", region: "Europe" },
  { value: "Europe/Sofia", region: "Europe" },
  { value: "Europe/Stockholm", region: "Europe" },
  { value: "Europe/Tallinn", region: "Europe" },
  { value: "Europe/Tirane", region: "Europe" },
  { value: "Europe/Tiraspol", region: "Europe" },
  { value: "Europe/Ulyanovsk", region: "Europe" },
  { value: "Europe/Vaduz", region: "Europe" },
  { value: "Europe/Vatican", region: "Europe" },
  { value: "Europe/Vienna", region: "Europe" },
  { value: "Europe/Vilnius", region: "Europe" },
  { value: "Europe/Volgograd", region: "Europe" },
  { value: "Europe/Warsaw", region: "Europe" },
  { value: "Europe/Zagreb", region: "Europe" },
  { value: "Europe/Zurich", region: "Europe" },
  { value: "GMT", region: "Other" },
  { value: "HST", region: "Other" },
  { value: "Indian/Antananarivo", region: "Indian" },
  { value: "Indian/Chagos", region: "Indian" },
  { value: "Indian/Christmas", region: "Indian" },
  { value: "Indian/Cocos", region: "Indian" },
  { value: "Indian/Comoro", region: "Indian" },
  { value: "Indian/Kerguelen", region: "Indian" },
  { value: "Indian/Mahe", region: "Indian" },
  { value: "Indian/Maldives", region: "Indian" },
  { value: "Indian/Mauritius", region: "Indian" },
  { value: "Indian/Mayotte", region: "Indian" },
  { value: "Indian/Reunion", region: "Indian" },
  { value: "MET", region: "Other" },
  { value: "MST", region: "Other" },
  { value: "MST7MDT", region: "Other" },
  { value: "PST8PDT", region: "Other" },
  { value: "Pacific/Apia", region: "Pacific" },
  { value: "Pacific/Auckland", region: "Pacific" },
  { value: "Pacific/Bougainville", region: "Pacific" },
  { value: "Pacific/Chatham", region: "Pacific" },
  { value: "Pacific/Chuuk", region: "Pacific" },
  { value: "Pacific/Easter", region: "Pacific" },
  { value: "Pacific/Efate", region: "Pacific" },
  { value: "Pacific/Fakaofo", region: "Pacific" },
  { value: "Pacific/Fiji", region: "Pacific" },
  { value: "Pacific/Funafuti", region: "Pacific" },
  { value: "Pacific/Galapagos", region: "Pacific" },
  { value: "Pacific/Gambier", region: "Pacific" },
  { value: "Pacific/Guadalcanal", region: "Pacific" },
  { value: "Pacific/Guam", region: "Pacific" },
  { value: "Pacific/Honolulu", region: "Pacific" },
  { value: "Pacific/Johnston", region: "Pacific" },
  { value: "Pacific/Kanton", region: "Pacific" },
  { value: "Pacific/Kiritimati", region: "Pacific" },
  { value: "Pacific/Kosrae", region: "Pacific" },
  { value: "Pacific/Kwajalein", region: "Pacific" },
  { value: "Pacific/Majuro", region: "Pacific" },
  { value: "Pacific/Marquesas", region: "Pacific" },
  { value: "Pacific/Midway", region: "Pacific" },
  { value: "Pacific/Nauru", region: "Pacific" },
  { value: "Pacific/Niue", region: "Pacific" },
  { value: "Pacific/Norfolk", region: "Pacific" },
  { value: "Pacific/Noumea", region: "Pacific" },
  { value: "Pacific/Pago_Pago", region: "Pacific" },
  { value: "Pacific/Palau", region: "Pacific" },
  { value: "Pacific/Pitcairn", region: "Pacific" },
  { value: "Pacific/Pohnpei", region: "Pacific" },
  { value: "Pacific/Port_Moresby", region: "Pacific" },
  { value: "Pacific/Rarotonga", region: "Pacific" },
  { value: "Pacific/Saipan", region: "Pacific" },
  { value: "Pacific/Samoa", region: "Pacific" },
  { value: "Pacific/Tahiti", region: "Pacific" },
  { value: "Pacific/Tarawa", region: "Pacific" },
  { value: "Pacific/Tongatapu", region: "Pacific" },
  { value: "Pacific/Wake", region: "Pacific" },
  { value: "Pacific/Wallis", region: "Pacific" },
  { value: "Pacific/Yap", region: "Pacific" },
  { value: "UTC", region: "Other" },
  { value: "WET", region: "Other" }
];

/**
 * Build a live, DST-correct display label for a zone, e.g.
 * "Asia/Kolkata (UTC+05:30)" or "America/New_York (UTC-04:00)".
 *
 * Offsets are computed at call time via Intl.DateTimeFormat rather than
 * baked into the static list above, since most zones observe DST and a
 * frozen offset would be wrong for roughly half the year.
 */
export function getTimezoneLabel(zone) {
  try {
    const parts = new Intl.DateTimeFormat("en-US", {
      timeZone: zone,
      timeZoneName: "longOffset",
    }).formatToParts(new Date());
    const offsetPart = parts.find((p) => p.type === "timeZoneName");
    const offset = offsetPart ? offsetPart.value.replace("GMT", "UTC") : "";
    return offset ? `${zone} (${offset})` : zone;
  } catch (e) {
    return zone;
  }
}

/** Options shaped for MUI Autocomplete: [{ label, value }], sorted by region then name. */
export function getTimezoneOptions() {
  return IANA_TIMEZONES
    .slice()
    .sort((a, b) => (a.region === b.region ? a.value.localeCompare(b.value) : a.region.localeCompare(b.region)))
    .map((tz) => ({ label: getTimezoneLabel(tz.value), value: tz.value, region: tz.region }));
}
